import './contactt.css';



function Appcontact() {
  

  
  return (
    <>
    <footer className="footer">
    <h2>Contact us Today</h2>
    
    <div className="content-wrapper">
    

    <a  href="https://www.whatsapp.com" className="nav-item">
          <img className="icon" src={"/images/whatsap.jpeg"} alt="whatsapp" /> WhatsApp:+2209914708
    </a>
        
        <a  href="https://www.facebook.com/profile.php?id=61566743746452" className="nav-item">
          <img className="icon" src={"/images/facebook.jpeg"} alt="facebook" />Follow us
        </a>
        

      </div>
      <div>
      </div>
    
  </footer>
    </>
  )
}

export default Appcontact;
